/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DimensionDefinitionConfiguration {
    getFixupPrototypeFunction() { return DimensionDefinitionConfiguration.fixupPrototype; }

    static newInstance(model: Partial<DimensionDefinitionConfiguration>): DimensionDefinitionConfiguration {
        let obj = Object.assign(new DimensionDefinitionConfiguration(), model);
        DimensionDefinitionConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DimensionDefinitionConfiguration>): DimensionDefinitionConfiguration {
        if (!model) return null;
        return DimensionDefinitionConfiguration.newInstance(<DimensionDefinitionConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DimensionDefinitionConfiguration) {
        if (!obj) return;

        models.DimensionDefinitionConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DimensionDefinitionConfiguration): boolean {
        Object.setPrototypeOf(obj, DimensionDefinitionConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
        if (typeof this.end_date === "string") {
            this.end_date = new Date(<string><any>this.end_date);
        }
        if (this.access_granted_identities) {
            models.AccessGrantedRolesAndUserGroups.fixupPrototype(this.access_granted_identities);
        }
        if (this.attributes) {
            for (let val of this.attributes) {
                models.AttributeDefinitionBase.fixupPrototype(val);
            }
        }
        if (this.grouping_rules) {
            for (let val of this.grouping_rules) {
                models.DimensionGroupingRule.fixupPrototype(val);
            }
        }
    }

    /**
     * Start date of the Dimension Definition
     */
    start_date: Date;

    /**
     * End date of the Dimension Definition
     */
    end_date: Date;

    /**
     * Is cost center enabled for the Dimension Definition
     */
    enable_cost_center: boolean;

    /**
     * Configured attributes for Dimension Definition
     */
    attributes: Array<models.AttributeDefinitionBase>;

    /**
     * Identities allowed to access this Dimension Definition
     */
    access_granted_identities: models.AccessGrantedRolesAndUserGroups;

    /**
     * Configured grouping rule for Dimension Definition
     */
    grouping_rules: Array<models.DimensionGroupingRule>;

    /**
     * Enable precomputation tagging of Dimension tagging on billing line items
     */
    precompute: boolean = false;

    /**
     * Enable Unallocated Cost grouping rule for this Dimension Version
     */
    include_unallocated_cost: boolean = false;

}
